import React from 'react';
import { useWindowDimensions } from 'react-native';
import styled from 'styled-components/native';
import GaugeChart from '../../components/charts/GaugeChart';

const StyledContainer = styled.View<{ isDesktop: boolean }>`
  flex-direction: ${p => (p.isDesktop ? 'row' : 'column')};
  justify-content: center;
  align-items: center;
  background: #fff;
  height: 100%;
`;

const StyledGaugeContainer = styled.View`
  padding: 40px 60px 20px 60px;
`;

const GaugeChartScreen: React.FC = () => {
  const window = useWindowDimensions();
  const isDesktop = window.width >= 768;
  return (
    <StyledContainer isDesktop={isDesktop}>
      <StyledGaugeContainer>
        <GaugeChart
          value={5}
          values={[
            '60MIN',
            '50MIN',
            '40MIN',
            '30MIN',
            '20MIN',
            '10MIN',
            '1MIN'
          ]}
          label='Impact-o-Meter'
          helperText='Minutes to fall asleep'
        />
      </StyledGaugeContainer>
      <StyledGaugeContainer>
        <GaugeChart
          value={2}
          values={['NONE', 'WEAK', 'MODERATE', 'STRONG', 'VERY STRONG']}
          label='Strength of Correlation'
        />
      </StyledGaugeContainer>
    </StyledContainer>
  );
};

export default GaugeChartScreen;
